import RequestHelper, {ActionAnswer} from "../utils/RequestsHelper"
import {AxiosPromise} from "axios"


export interface CategoryNestedSet {
    id: string
    name: string
    parent_id: string
    categories: {[id: string]: CategoryNestedSet}
    depth: string
}

export interface allSetsAndCategories {
    sets: {
        count: string
        categories_to_export: string
        edit_datetime: null | string
        id: string
        json_params: null | string
        name: string
        sort: string
        rule: null | string
        type: string
    }[]
    categories: CategoryNestedSet[]
}

export interface ChooseCategoriesGet {
    exportAll: boolean
    categories_to_export: string[]
    sets_to_export: { label: string, value: string }[]
}
export interface productExportConditions{
    hidden: boolean
    unavailable: boolean
    infinity: boolean
    minPrice: number
}

export interface allExport {
    exportAll: number
    conditions: productExportConditions
    sets: string[]
    categories: string[]
    type: string
}

export default class ChooseCategoriesApi {

    public static get(): AxiosPromise<ActionAnswer<ChooseCategoriesGet>> {
        return RequestHelper.send("get", "chooseCategories&action=exported")
    }

    public static getAllSetsAndCategories(): AxiosPromise<ActionAnswer<allSetsAndCategories>> {
        return RequestHelper.send("get", "chooseCategories&action=allSetsAndCategories")
    }

    public static saveCategories(checked: string[]): AxiosPromise<ActionAnswer<ChooseCategoriesGet>> {
        return RequestHelper.send("post",
            "chooseCategories&action=exportedCategories",
            {checked})
    }

    public static saveSets(chosenSets: string[]): AxiosPromise<ActionAnswer<ChooseCategoriesGet>> {
        return RequestHelper.send("post",
            "chooseCategories&action=exportedSets",
            {chosenSets})
    }

    public static saveExportAll(exportAll: boolean): AxiosPromise<ActionAnswer<ChooseCategoriesGet>> {
        return RequestHelper.send("post",
            "chooseCategories&action=exportAll",
            {exportAll: exportAll ? 1 : 0})
    }

    public static getProductExportConditions(): AxiosPromise<ActionAnswer<productExportConditions>> {
        return RequestHelper.send("get",
            "chooseCategories&action=productExportConditions")
    }

    public static saveProductExportConditions(conditions: productExportConditions): AxiosPromise<ActionAnswer<productExportConditions>> {
        return RequestHelper.send("post",
            "chooseCategories&action=productExportConditions", conditions)
    }

    public static saveAll(data: allExport): AxiosPromise<ActionAnswer<allExport>> {
        return RequestHelper.send("post",
            "chooseCategories&action=saveAll", data)
    }
}